import {memo, useCallback} from 'react'

import {IcInfo, useBottomModal} from '@defign/ui'
import {Action, sendAULog} from '@financial/common-logs'
import classNames from 'classnames/bind'

import {Radar} from '$components/insurance/chart/radar'
import GraphModal from '$components/insurance/my/home/diagnosis/GraphModal'
import auBases from '$constants/auBases'
import {또래대비_보장조건} from '$constants/insurance/diagnosis'
import {useDiagnosisCoverage} from '$hooks/insurance/my/home/diagnosis/useDiagnosisCoverage'
import {GRAPH_LABEL} from '$share/constants/insurance'
import {sendClickNlog} from '$utils/nlog'

import styles from './InsuranceGraph.module.scss'

const cx = classNames.bind(styles)

const mockCoverages = [
    {
        condition: 또래대비_보장조건.충분,
        myRank: 0,
        labelName: GRAPH_LABEL.실손,
        myAmount: 75,
        peerAmount: 74,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.매우부족,
        myRank: 0,
        labelName: GRAPH_LABEL.암,
        myAmount: 48,
        peerAmount: 72,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.부족,
        myRank: 0,
        labelName: GRAPH_LABEL.뇌,
        myAmount: 53,
        peerAmount: 74,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.부족,
        myRank: 0,
        labelName: GRAPH_LABEL.심장,
        myAmount: 57,
        peerAmount: 75,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.충분,
        myRank: 0,
        labelName: GRAPH_LABEL.사망,
        myAmount: 78,
        peerAmount: 76,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.충분,
        myRank: 0,
        labelName: GRAPH_LABEL.입원,
        myAmount: 35,
        peerAmount: 73,
        maxAmount: 100,
    },
    {
        condition: 또래대비_보장조건.충분,
        myRank: 0,
        labelName: GRAPH_LABEL.후유장해,
        myAmount: 51,
        peerAmount: 74,
        maxAmount: 100,
    },
]

const DefaultRadar = memo(function DefaultRadar() {
    return <Radar coverages={mockCoverages} />
})

const ConnectedRadar = memo(function ConnectedRadar() {
    const {coverages} = useDiagnosisCoverage()

    return <Radar coverages={coverages} />
})

interface InsuranceGraphProps {
    shouldShowInfo: boolean
}
function InsuranceGraph({shouldShowInfo}: InsuranceGraphProps) {
    const {open, close} = useBottomModal()
    const handleOpenModal = useCallback(() => {
        sendClickNlog('insumy.diagnosischeckmytooltip')
        sendAULog({...auBases.insurance.homeD, code: 'insu_check_coverages_tooltip'}, Action.Click)

        open({
            children: <GraphModal onClick={close} />,
            onClickDimmedLayer: close,
            isShowCloseButton: false,
            closeButtonText: '보장금액 기준',
        })
    }, [close, open])

    return (
        <div className={cx('article')}>
            <div className={cx('graph')}>{shouldShowInfo ? <ConnectedRadar /> : <DefaultRadar />}</div>
            {shouldShowInfo && (
                <div className={cx('graph-dot')}>
                    <span className={cx('dot')}>
                        <span className="blind">하늘색 형상의 경우</span>
                        또래 평균
                    </span>
                    <span className={cx('dot')}>
                        <span className="blind">네온그린 형상의 경우</span>내 보장
                        <button type="button" className={cx('tooltip')} onClick={handleOpenModal}>
                            <IcInfo width={13} height={13} fill="#767678" />
                            <span className="blind">툴팁 보기</span>
                        </button>
                    </span>
                </div>
            )}
        </div>
    )
}

export default InsuranceGraph
